export default __webpack_public_path__ + "static/media/V_Vaso.7f6378a4.mp3";